import api from '../../../axios/axios-api'

export default {
  async fetchVinculos({ rootState }, payload) {
    const params = {}
    const fichaId = Number(
      payload && Object.prototype.hasOwnProperty.call(payload, 'fichaId')
        ? payload.fichaId
        : rootState?.portalHome?.activePortalFichaId,
    )
    if (Number.isFinite(fichaId) && fichaId > 0) params.fichaId = fichaId
    const { data } = await api.get('GrupoFamiliar', { params })
    return Array.isArray(data) ? data : []
  },
  async fetchParentescosParaFicha() {
    const { data } = await api.get('Taxonomy/parentescos-para-ficha')
    const arr = Array.isArray(data) ? data : []
    return arr.filter((x) => x?.id > 0 && x?.value)
  },
  async agregarVinculo(_ctx, payload) {
    const { data } = await api.post('GrupoFamiliar', payload)
    return data
  },
  async eliminarVinculo(_ctx, fichaParentescoId) {
    await api.delete(`GrupoFamiliar/${fichaParentescoId}`)
  },
}
